// extracted by mini-css-extract-plugin
export var dropdown = "_qq-0";
export var imageWrapper = "_qq-3";
export var itemNameContainer = "_qq-1";
export var productImage = "_qq-2";
export var spinnerWrapper = "_qq-4";